import dayjs from 'dayjs';
import { formatDate } from '../../../../utils/date';

export type BannerDisplayStatus = 'permanent' | 'scheduled' | 'active' | 'expired';

interface BannerPeriod {
    isPermanent: boolean;
    startDate?: string;
    endDate?: string;
}

// Situação do período de exibição, comparando só a data (como o portal faz)
export function getBannerDisplayStatus(banner: BannerPeriod, today: Date = new Date()): BannerDisplayStatus {
    if (banner.isPermanent) return 'permanent';
    const day = dayjs(today).startOf('day');
    if (banner.startDate && dayjs(banner.startDate).startOf('day').isAfter(day)) return 'scheduled';
    if (banner.endDate && dayjs(banner.endDate).startOf('day').isBefore(day)) return 'expired';
    return 'active';
}

export function formatBannerPeriod(banner: BannerPeriod): string {
    if (banner.isPermanent) return 'Exibição permanente';
    return `${formatDate(banner.startDate) || '?'} a ${formatDate(banner.endDate) || '?'}`;
}
